// Components==============
import Message from 'components/UI/Message/Message';
import MessageBar from 'components/UI/MessageBar/MessageBar';
import Spinner from 'components/UI/Spinner/Spinner';
import { ProjectCommunicationContextType } from 'pages/Workspace/ProjectDetails/components/Communication/Communication';
import React, { createContext, useEffect, useRef } from 'react';
import './Chat.module.scss';
import SideMenu from './SideMenu/SideMenu';
// =========================

export const ChatContext = createContext({} as ProjectCommunicationContextType);

export default function Chat(props: ProjectCommunicationContextType) {
  const ref = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const {
    loading,
    activeChannel,
    toggleGoToBottom,
    messages,
    inputValue,
    setInputValue,
    sendMessage,
    deleteMessage,
  } = props;

  useEffect(() => {
    if (ref?.current) ref.current.scrollTop = 500000;
    if (inputRef?.current) inputRef.current.focus();
  }, [loading, activeChannel, toggleGoToBottom]);

  if (!activeChannel?.id || activeChannel.id < 0) return <> </>;

  function handleDelete(id: number) {
    deleteMessage(id);
  }

  return (
    <ChatContext.Provider value={props}>
      <div styleName={`wrapper ${activeChannel?.phase}`}>
        <div styleName="chat-wrapper">
          <div styleName="top">
            <h4>{activeChannel?.name}</h4>
          </div>
          <div styleName="chat">
            {loading ? (
              <Spinner fullPage />
            ) : (
              <div styleName="scroll-container" ref={ref}>
                <div styleName="messages">
                  {messages?.map(
                    (message, i) =>
                      !!message && (
                        <Message
                          message={message}
                          key={i}
                          type={
                            activeChannel.type === 'App\\User'
                              ? 'direct-message'
                              : 'project'
                          }
                          handleDelete={handleDelete}
                        />
                      )
                  )}
                </div>
              </div>
            )}
            <MessageBar
              inputValue={inputValue}
              setInputValue={setInputValue}
              handleSubmit={sendMessage}
              inputRef={inputRef}
              paddingRight="1em"
            />
          </div>
        </div>
        <SideMenu />
      </div>
    </ChatContext.Provider>
  );
}
